import { render, staticRenderFns } from "./ItemEmptyDefaultLayout.vue?vue&type=template&id=c71c5ec6&scoped=true&"
import script from "./ItemEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./ItemEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71c5ec6",
  null
  
)

export default component.exports